export default __webpack_public_path__ + "static/media/banner-clean.a7e21e72.png";